import { api } from '@/config/api';
export interface DashboardOverview {
  totalCompanies: number;
  byStatus: Record<string, number>;
  totalUsers: number;
  expiringSoon: Array<{ companyUid: string; name: string; expiresAt: string; status: string }>;
  aiCreditsUsedThisMonth: number;
  signupsByDay: Array<{ _id: string; count: number }>;
}
export const dashboardService = {
  overview: async (): Promise<DashboardOverview> => (await api.get('/super_admin/dashboard/overview')).data,
};
